const ON_CHANGE_DEBOUNCE_TIMER = 300;

/**
 * Certificate variant ID - used to identify gift certificate items in cart
 * This should match the variant ID of your gift certificate product
 */
const CERTIFICATE_VARIANT_ID = 45420259705055;

/**
 * Animation and timing constants
 */
const TIMING = {
  // Delay before removing old DOM nodes after view transition (in milliseconds)
  VIEW_TRANSITION_REMOVE_DELAY: 500,
  // Delay after adding free gift to cart before refreshing (in milliseconds)
  FREE_GIFT_ADD_DELAY: 150,
  // Default debounce timer for input changes (in milliseconds)
  DEBOUNCE_DEFAULT: 300
};

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
